import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {showVideoFlag} from './actions';
import {Api} from './util';

import Login from './containers/login';

import {
  Navigation,
  VideoContainer,
  ContentContainer
} from './containers';



class App extends Component {
  constructor(props){      
    super(props);
    this.state = {
      // showVideo: false,
    };
    this.videoHandler = this.videoHandler.bind(this);
    this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
    this.requestReload = this.requestReload.bind(this);
    this.handleLogoutClose = this.handleLogoutClose.bind(this);
    this.appDOM = createRef();
  }
  componentDidMount() {
    console.log(process.env.REACT_IP);
    if(this.appDOM.current) this.appDOM.current.focus();
  }
  
  videoHandler(){
    // const {showVideo} = this.state;
    // this.setState({
    //   showVideo: !showVideo
    // })
    const {videoFlag} = this.props;
    this.props.showVideoFlag(!videoFlag);
  }
  handleOnKeyUp(e){
    const {selectedMenu, modalFlag} = this.props;
    if(e.keyCode === 32 && selectedMenu === 'SCHEDULE' && !modalFlag){
      window.location.href = '#timeline-onair ';
      this.appDOM.current.focus();
    }
  }

  requestReload() {
    this.setState((prevState) => {
      return {
        reloadToggle: !prevState.reloadToggle
      }
    });
  }

  async handleLogoutClose(){
    try{
      await Api.LogoutEx();
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    } catch(e){
      console.log(e);
    }
  }


  render() {
    // const {showVideo} = this.state;
    const {videoFlag, selectedMenu} = this.props;
    const video = {
      // top: '-104px',
      top: '-133px',
      width: '100%',
      position: 'absolute'
    };
     
    const toggle = {
      // top: '100px',
      top: '133px',
      right: '17px'
    };

    const division = {
      display: "none"
    }

    const showVideoIcon = classnames('icon', {
      'video-close' : videoFlag,
      'video-open' : !videoFlag,
    });

    const searchClass = classnames('bottom-container', {
      'toggle' : videoFlag
    })

    // NOTE: TIME-LINE위치로 애니메이션 효과개발
    
    const loginFlag = !sessionStorage.getItem('id') || !sessionStorage.getItem('login');
    const Components = loginFlag ? (
      <div id='mxv-logger'>
        <Login requestReload={this.requestReload}/>
      </div>
    ):(
      <div id='mxv-logger' onKeyUp={this.handleOnKeyUp} tabIndex="0" 
        ref={this.appDOM}> 
        <div className='top-container' style={selectedMenu === "DIVISION" ? video : videoFlag ? null : video} >
        <div className='video-toggle' 
            onClick={this.videoHandler}
            style={selectedMenu === "DIVISION" ? division : videoFlag ? null : toggle} >
          <span className={showVideoIcon}></span>
        </div>
        <Navigation handleLogoutClose={this.handleLogoutClose}/>
        <VideoContainer showVideo={videoFlag}/>
        </div>
        <div className={searchClass}>
          <ContentContainer />
        </div>
      </div>
    )

    return Components;
  }
}
const mapStateToProps = (state) => {
  return {
    videoFlag: state.videoFlag,
    modalFlag: state.modalFlag,
    selectedMenu: state.selectedMenu
  }
};
const mapDispatcherToProps = dispatch => {
  return {
    showVideoFlag: (videoFlag) => dispatch(showVideoFlag(videoFlag)),
  }
};

App = connect(mapStateToProps,mapDispatcherToProps)(App);
export default App;



// WEBPACK FOOTER //
// ./src/App.js